var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaverSolution6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5939 14.3916C8.83244 14.3916 6.59386 16.6302 6.59386 19.3916V56.0382H3.66797V62.4956H38.9058V56.0382H35.9791V19.3916C35.9791 16.6302 33.7406 14.3916 30.9791 14.3916H11.5939Z",
    fill: "url(#paint0_linear_2137_19469)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3292 14.3916C27.5678 14.3916 25.3292 16.6302 25.3292 19.3916V56.0381H20.4395V62.4955H48.5246V56.0381H43.4506V19.3916C43.4506 16.6302 41.212 14.3916 38.4506 14.3916H30.3292Z",
    fill: "url(#paint1_linear_2137_19469)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5079 24.2432C33.7465 24.2432 31.5079 26.4817 31.5079 29.2432V57.3606H28.582V62.4955H63.8199V57.3606H60.8932V29.2432C60.8932 26.4817 58.6546 24.2432 55.8932 24.2432H36.5079Z",
    fill: "url(#paint2_linear_2137_19469)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.25 24.2432C52.4886 24.2432 50.25 26.4817 50.25 29.2432V57.3606H45.3594V62.4955H73.4445V57.3606H68.3714V29.2432C68.3714 26.4817 66.1328 24.2432 63.3713 24.2432H55.25Z",
    fill: "url(#paint3_linear_2137_19469)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7227 45.9982C35.7227 43.5805 37.6826 41.6206 40.1003 41.6206V41.6206C42.518 41.6206 44.4779 43.5805 44.4779 45.9982V56.0815H35.7227V45.9982Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7227 45.9982C35.7227 43.5805 37.6826 41.6206 40.1003 41.6206V41.6206C42.518 41.6206 44.4779 43.5805 44.4779 45.9982V56.0815H35.7227V45.9982Z",
    fill: "url(#paint4_linear_2137_19469)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8066 45.9982C10.8066 43.5805 12.7666 41.6206 15.1843 41.6206V41.6206C17.602 41.6206 19.5619 43.5805 19.5619 45.9982V56.0815H10.8066V45.9982Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8066 45.9982C10.8066 43.5805 12.7666 41.6206 15.1843 41.6206V41.6206C17.602 41.6206 19.5619 43.5805 19.5619 45.9982V56.0815H10.8066V45.9982Z",
    fill: "url(#paint5_linear_2137_19469)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.0176,
    y: 28.9478,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0176,
    y: 28.9478,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "url(#paint6_linear_2137_19469)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5547,
    y: 28.9478,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5547,
    y: 28.9478,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "url(#paint7_linear_2137_19469)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.09766,
    y: 18.8555,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.09766,
    y: 18.8555,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "url(#paint8_linear_2137_19469)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6348,
    y: 18.8555,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6348,
    y: 18.8555,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "url(#paint9_linear_2137_19469)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19469",
    x1: 17.7622,
    y1: 30.4312,
    x2: -20.6882,
    y2: 84.5884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EA0D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_19469",
    x1: 38.422,
    y1: 25.377,
    x2: 20.5938,
    y2: 86.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2137_19469",
    x1: 42.6762,
    y1: 36.9979,
    x2: 14.9454,
    y2: 86.1159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EA0D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2137_19469",
    x1: 63.3419,
    y1: 32.9787,
    x2: 51.7386,
    y2: 83.3982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2137_19469",
    x1: 41.3285,
    y1: 44.923,
    x2: 36.1321,
    y2: 63.5428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2137_19469",
    x1: 16.4125,
    y1: 44.923,
    x2: 11.2161,
    y2: 63.5428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2137_19469",
    x1: 36.201,
    y1: 29.7274,
    x2: 35.4217,
    y2: 34.3339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2137_19469",
    x1: 40.7381,
    y1: 29.7274,
    x2: 39.9588,
    y2: 34.3339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2137_19469",
    x1: 11.281,
    y1: 19.6351,
    x2: 10.5018,
    y2: 24.2416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2137_19469",
    x1: 15.8181,
    y1: 19.6351,
    x2: 15.0389,
    y2: 24.2416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverSolution6);
export default __webpack_public_path__ + "static/media/naverSolution6.bae4cf983b0d34a2fa66f866623d183f.svg";
export { ForwardRef as ReactComponent };